import * as _ from 'lodash';
import { CampPricing } from '@/store/modules/camp-form/camp-pricing';
import { getCurrentHoursAndMinutes } from '@/common/utils/dates';

export const STEPS = [
    'Details',
    'Groups',
    'Dates & Times',
    'Fees & Addons'
];

export const DEFAULT_STATE_MULTI_CHILD_DISCOUNT = {
    id: null,
    bonusType: null,
    amount: null,
    after: null,
    active: false
};

export const DEFAULT_STATE_EARLY_BIRD_DISCOUNT = {
    id: null,
    bonusType: null,
    amount: null,
    endDate: null,
    active: false
};

export const DEFAULT_STATE_MULTI_PROGRAM_DISCOUNT = {
    id: null,
    bonusType: null,
    amount: null,
    after: null,
    active: false
};

export const DEFAULT_STATE = {
    camp: {
        campName: '',
        description: null,
        instructorId: 0,
        locationId: 0,
        formIds: [],
        campStartDate: null,
        campEndDate: null,
        signUpBeginsDate: new Date(),
        signUpEndsDate: null,
        signUpBeginsTime: getCurrentHoursAndMinutes(),
        signUpEndsTime: '16:30',
        waitList: false,
        prorate: false,
        sunday: false,
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        noCampDates: [],
        pickUpOptions: false,
        pickUpOptionsRequired: false,
        teacher: false,
        teacherRequired: false,
        tshirt: false,
        tshirtRequired: false
    },
    addOns: [],
    pricings: [new CampPricing()],
    multiChildDiscount: _.clone(DEFAULT_STATE_MULTI_CHILD_DISCOUNT),
    earlyBirdDiscount: _.clone(DEFAULT_STATE_EARLY_BIRD_DISCOUNT),
    multiProgramDiscount: _.clone(DEFAULT_STATE_MULTI_PROGRAM_DISCOUNT)
};


// WEBPACK FOOTER //
// ./src/store/modules/camp-form/default-state.js